<template>

  <!-- TABLE -->
  <tr
  :class="{'selected': selected[item.id]}">
    <td class="sticky">

      <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            color="grey"
            v-on="on"
          >
            <v-icon small>mdi-android-debug-bridge</v-icon>
          </v-btn>
        </template>
        <v-card outlined class="elevation-0">
          <v-layout class="backgroundCard pa-2 caption">
            JSON
          </v-layout>
          <div class="c-hr"></div>
          <div class="pa-3">
            <span class="caption">
              {{ item }}
              <json-viewer :item="item"></json-viewer>
            </span>
          </div>
        </v-card>
      </v-menu>

      <transition
      name="slide-x-transition"
      appear
      hide-on-leave
      mode="out-in">
        <v-icon v-if="itemsMeta.newID === item.id" color="color1" style="position: absolute; left: 0px; top: 0px;">mdi-new-box</v-icon>
      </transition>

      <v-layout align-center>
        <v-btn
        icon
        @click.stop="$emit('checkRow', item)">
          <v-icon> 
            {{ selected[item.id] ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </v-btn>
        <img class="c-align-self-start" src="@/assets/img/illustrations/purse.png" alt="cardboard box" width="35px">
        <span 
        class=""
        v-html="highlightedID">
        </span>
      </v-layout>
    </td>
    <td>
      {{ item.item_count }} items
    </td>
    <td>
      {{ item.customer_name }}
    </td>
    <td>
      <v-icon small color="text darken-1">mdi-clock-outline</v-icon>
      {{ humanDate }}
      <div :class="['text-ellipsed']">
      {{ dateFromNow }}
      </div>
    </td>
  </tr>
</template>

<script>
import JsonViewer from '@/components/toolbox/json-viewer/Main'

export default {
  props:['item', 'itemsMeta', 'searchTextID', 'selected'],
  components: {
    JsonViewer
  },
  data () {
    return {
      hover: false
    }
  },
  computed: {
    highlightedID () {
      var replacedStr = (this.searchTextID || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      replacedStr = this.item.id.toString().replace(new RegExp(replacedStr, 'gi'), '<span class="green--text">$&</span>')
      return '<span class="font-weight-bold">' + replacedStr + '</span>'
    },
    humanDate () {
      if (this.$moment.utc(this.item.date).isValid()) {
        return this.$moment(this.item.date).format('ddd DD MMM')
      }
      return ''
    },
    dateFromNow () {
      if (this.$moment.utc(this.item.date).isValid()) {
        return this.$moment.utc(this.item.date).fromNow()
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">

</style>